import { type IdeaStatusLogResponse, IdeaStatusLogResponseSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';

type Options = {
  enabled?: boolean;
};

export const ideaHistoryKey = (ideaId: string) => ['idea-history', ideaId] as const;

export const useIdeaHistory = (ideaId: string, options: Options = {}) => {
  return useQuery<IdeaStatusLogResponse>({
    queryKey: ideaHistoryKey(ideaId),
    queryFn: async () => {
      const raw = await apiFetch<unknown>(`/ideas/${ideaId}/status-log`);
      return IdeaStatusLogResponseSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 30_000,
  });
};
